import React, { useState, useEffect } from 'react';
import './APIKeysManager.css';
import config from '../config'; // ✅ استيراد الـ base URL

// ✅ دالة مساعدة لبناء URL صحيح مع base URL
const apiURL = (path) => `${config.PASSPORT_API_URL}${path}`;

const APIKeysManager = () => {
    const [keys, setKeys] = useState([]);
    const [activeService, setActiveService] = useState('Gemini');
    const [stats, setStats] = useState({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [loading, setLoading] = useState(false);
    
    // بيانات المفتاح الجديد
    const [newKey, setNewKey] = useState({
        serviceType: 'Gemini',
        keyName: '',
        apiKey: '',
        endpoint: '',
        notes: ''
    });
    
    // بيانات المفتاح المراد تعديله
    const [editKey, setEditKey] = useState({
        keyId: null,
        serviceType: '',
        keyName: '',
        apiKey: '',
        endpoint: '',
        notes: ''
    });

    // ════════════════════════════════════════════════════════════
    // تحميل البيانات
    // ════════════════════════════════════════════════════════════
    
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            
            // تحميل جميع المفاتيح
            const keysRes = await fetch(apiURL('/api/ocr-settings/keys'));
            const keysData = await keysRes.json();
            if (keysData.success) {
                setKeys(keysData.keys);
            }
            
            // تحميل الخدمة النشطة
            const serviceRes = await fetch(apiURL('/api/ocr-settings/active-service'));
            const serviceData = await serviceRes.json();
            if (serviceData.success) {
                setActiveService(serviceData.activeService);
            }
            
            // تحميل الإحصائيات
            const statsRes = await fetch(apiURL('/api/ocr-settings/stats'));
            const statsData = await statsRes.json();
            if (statsData.success) {
                setStats(statsData.stats);
            }
            
        } catch (error) {
            console.error('خطأ في تحميل البيانات:', error);
            alert('خطأ في تحميل البيانات');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // إضافة مفتاح جديد
    // ════════════════════════════════════════════════════════════
    
    const handleAddKey = async (e) => {
        e.preventDefault();
        
        if (!newKey.keyName || !newKey.apiKey) {
            alert('يرجى إدخال اسم المفتاح والمفتاح نفسه');
            return;
        }
        
        if (newKey.serviceType === 'Azure' && !newKey.endpoint) {
            alert('يرجى إدخال Endpoint لخدمة Azure');
            return;
        }
        
        try {
            setLoading(true);
            
            const res = await fetch(apiURL('/api/ocr-settings/keys'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newKey)
            });
            
            const data = await res.json();
            
            if (data.success) {
                alert('تم إضافة المفتاح بنجاح');
                setShowAddModal(false);
                setNewKey({
                    serviceType: 'Gemini',
                    keyName: '',
                    apiKey: '',
                    endpoint: '',
                    notes: ''
                });
                loadData();
            } else {
                alert('خطأ: ' + data.error);
            }
        } catch (error) {
            console.error('خطأ في إضافة المفتاح:', error);
            alert('خطأ في إضافة المفتاح');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // فتح modal تعديل المفتاح
    // ════════════════════════════════════════════════════════════
    
    const handleOpenEditModal = async (key) => {
        try {
            setLoading(true);
            
            // الحصول على البيانات الكاملة للمفتاح
            const res = await fetch(apiURL(`/api/ocr-settings/keys/active/${key.ServiceType}`));
            const data = await res.json();
            
            if (data.success && data.key) {
                setEditKey({
                    keyId: key.KeyID,
                    serviceType: key.ServiceType,
                    keyName: key.KeyName,
                    apiKey: data.key.APIKey, // المفتاح الكامل
                    endpoint: data.key.Endpoint || '',
                    notes: key.Notes || ''
                });
                setShowEditModal(true);
            } else {
                alert('خطأ في تحميل بيانات المفتاح');
            }
        } catch (error) {
            console.error('خطأ في فتح modal التعديل:', error);
            alert('خطأ في تحميل البيانات');
        } finally {
            setLoading(false);
        }
    };
    
    // ════════════════════════════════════════════════════════════
    // حفظ تعديل المفتاح
    // ════════════════════════════════════════════════════════════
    
    const handleSaveEdit = async (e) => {
        e.preventDefault();
        
        if (!editKey.keyName) {
            alert('يرجى إدخال اسم المفتاح');
            return;
        }
        
        if (editKey.serviceType === 'Azure' && !editKey.endpoint) {
            alert('يرجى إدخال Endpoint لخدمة Azure');
            return;
        }
        
        try {
            setLoading(true);
            
            const res = await fetch(apiURL(`/api/ocr-settings/keys/${editKey.keyId}`), {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    keyName: editKey.keyName,
                    apiKey: editKey.apiKey || undefined,
                    endpoint: editKey.endpoint || undefined,
                    notes: editKey.notes || undefined
                })
            });
            
            const data = await res.json();
            
            if (data.success) {
                alert('تم تحديث المفتاح بنجاح');
                setShowEditModal(false);
                setEditKey({
                    keyId: null,
                    serviceType: '',
                    keyName: '',
                    apiKey: '',
                    endpoint: '',
                    notes: ''
                });
                loadData();
            } else {
                alert('خطأ: ' + data.error);
            }
        } catch (error) {
            console.error('خطأ في تحديث المفتاح:', error);
            alert('خطأ في تحديث المفتاح');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // تفعيل مفتاح
    // ════════════════════════════════════════════════════════════
    
    const handleActivateKey = async (keyId) => {
        if (!window.confirm('هل تريد تفعيل هذا المفتاح؟')) return;
        
        try {
            setLoading(true);
            
            const res = await fetch(apiURL(`/api/ocr-settings/keys/${keyId}/activate`), {
                method: 'PUT'
            });
            
            const data = await res.json();
            
            if (data.success) {
                alert('تم تفعيل المفتاح بنجاح');
                loadData();
            } else {
                alert('خطأ: ' + data.error);
            }
        } catch (error) {
            console.error('خطأ في تفعيل المفتاح:', error);
            alert('خطأ في تفعيل المفتاح');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // حذف مفتاح
    // ════════════════════════════════════════════════════════════
    
    const handleDeleteKey = async (keyId) => {
        if (!window.confirm('هل تريد حذف هذا المفتاح؟ لا يمكن التراجع عن هذا الإجراء.')) return;
        
        try {
            setLoading(true);
            
            const res = await fetch(apiURL(`/api/ocr-settings/keys/${keyId}`), {
                method: 'DELETE'
            });
            
            const data = await res.json();
            
            if (data.success) {
                alert('تم حذف المفتاح بنجاح');
                loadData();
            } else {
                alert('خطأ: ' + data.error);
            }
        } catch (error) {
            console.error('خطأ في حذف المفتاح:', error);
            alert('خطأ في حذف المفتاح');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // التبديل بين Azure و Gemini
    // ════════════════════════════════════════════════════════════
    
    const handleSwitchService = async (serviceType) => {
        if (serviceType === activeService) return;
        
        if (!window.confirm(`هل تريد التبديل إلى ${serviceType}؟`)) return;
        
        try {
            setLoading(true);
            
            const res = await fetch(apiURL('/api/ocr-settings/switch-service'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ serviceType })
            });
            
            const data = await res.json();
            
            if (data.success) {
                alert(`تم التبديل إلى ${serviceType} بنجاح`);
                setActiveService(serviceType);
                loadData();
            } else {
                alert('خطأ: ' + data.error);
            }
        } catch (error) {
            console.error('خطأ في تبديل الخدمة:', error);
            alert('خطأ في تبديل الخدمة');
        } finally {
            setLoading(false);
        }
    };

    // ════════════════════════════════════════════════════════════
    // فلترة المفاتيح حسب النوع
    // ════════════════════════════════════════════════════════════
    
    const geminiKeys = keys.filter(k => k.ServiceType === 'Gemini');
    const azureKeys = keys.filter(k => k.ServiceType === 'Azure');

    return (
        <div className="apikeys-manager">
            <div className="apikeys-header">
                <h1>🔑 إدارة مفاتيح OCR</h1>
                <button 
                    className="btn-add"
                    onClick={() => setShowAddModal(true)}
                    disabled={loading}
                >
                    ➕ إضافة مفتاح جديد
                </button>
            </div>

            {/* ════════════════════════════════════════════════════════ */}
            {/* اختيار الخدمة النشطة */}
            {/* ════════════════════════════════════════════════════════ */}
            
            <div className="service-selector">
                <h2>الخدمة النشطة حالياً</h2>
                <div className="service-buttons">
                    <button
                        className={`service-btn ${activeService === 'Gemini' ? 'active' : ''}`}
                        onClick={() => handleSwitchService('Gemini')}
                        disabled={loading}
                    >
                        <span className="icon">🤖</span>
                        <span className="name">Gemini</span>
                        {activeService === 'Gemini' && <span className="badge">نشط</span>}
                    </button>
                    
                    <button
                        className={`service-btn ${activeService === 'Azure' ? 'active' : ''}`}
                        onClick={() => handleSwitchService('Azure')}
                        disabled={loading}
                    >
                        <span className="icon">☁️</span>
                        <span className="name">Azure</span>
                        {activeService === 'Azure' && <span className="badge">نشط</span>}
                    </button>
                </div>
            </div>

            {/* ════════════════════════════════════════════════════════ */}
            {/* مفاتيح Gemini */}
            {/* ════════════════════════════════════════════════════════ */}
            
            <div className="keys-section">
                <h2>🤖 مفاتيح Gemini ({geminiKeys.length})</h2>
                
                {geminiKeys.length === 0 ? (
                    <div className="no-keys">
                        <p>لا توجد مفاتيح Gemini. قم بإضافة مفتاح جديد.</p>
                    </div>
                ) : (
                    <div className="keys-grid">
                        {geminiKeys.map(key => (
                            <div 
                                key={key.KeyID} 
                                className={`key-card ${key.IsActive ? 'active' : ''}`}
                            >
                                <div className="key-header">
                                    <h3>{key.KeyName}</h3>
                                    {key.IsActive && <span className="active-badge">نشط</span>}
                                </div>
                                
                                <div className="key-details">
                                    <div className="detail">
                                        <span className="label">المفتاح:</span>
                                        <code>{key.APIKeyPreview}</code>
                                    </div>
                                    
                                    {key.Notes && (
                                        <div className="detail">
                                            <span className="label">ملاحظات:</span>
                                            <span>{key.Notes}</span>
                                        </div>
                                    )}
                                    
                                    <div className="detail">
                                        <span className="label">تاريخ الإضافة:</span>
                                        <span>{new Date(key.CreatedAt).toLocaleDateString('ar-EG')}</span>
                                    </div>
                                </div>
                                
                                <div className="key-actions">
                                    {!key.IsActive && (
                                        <button
                                            className="btn-activate"
                                            onClick={() => handleActivateKey(key.KeyID)}
                                            disabled={loading}
                                        >
                                            ✅ تفعيل
                                        </button>
                                    )}
                                    
                                    <button
                                        className="btn-edit"
                                        onClick={() => handleOpenEditModal(key)}
                                        disabled={loading}
                                    >
                                        ✏️ تعديل
                                    </button>
                                    
                                    <button
                                        className="btn-delete"
                                        onClick={() => handleDeleteKey(key.KeyID)}
                                        disabled={loading || key.IsActive}
                                    >
                                        🗑️ حذف
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* ════════════════════════════════════════════════════════ */}
            {/* مفاتيح Azure */}
            {/* ════════════════════════════════════════════════════════ */}
            
            <div className="keys-section">
                <h2>☁️ مفاتيح Azure ({azureKeys.length})</h2>
                
                {azureKeys.length === 0 ? (
                    <div className="no-keys">
                        <p>لا توجد مفاتيح Azure. قم بإضافة مفتاح جديد.</p>
                    </div>
                ) : (
                    <div className="keys-grid">
                        {azureKeys.map(key => (
                            <div 
                                key={key.KeyID} 
                                className={`key-card ${key.IsActive ? 'active' : ''}`}
                            >
                                <div className="key-header">
                                    <h3>{key.KeyName}</h3>
                                    {key.IsActive && <span className="active-badge">نشط</span>}
                                </div>
                                
                                <div className="key-details">
                                    <div className="detail">
                                        <span className="label">المفتاح:</span>
                                        <code>{key.APIKeyPreview}</code>
                                    </div>
                                    
                                    <div className="detail">
                                        <span className="label">Endpoint:</span>
                                        <code>{key.EndpointPreview}</code>
                                    </div>
                                    
                                    {key.Notes && (
                                        <div className="detail">
                                            <span className="label">ملاحظات:</span>
                                            <span>{key.Notes}</span>
                                        </div>
                                    )}
                                    
                                    <div className="detail">
                                        <span className="label">تاريخ الإضافة:</span>
                                        <span>{new Date(key.CreatedAt).toLocaleDateString('ar-EG')}</span>
                                    </div>
                                </div>
                                
                                <div className="key-actions">
                                    {!key.IsActive && (
                                        <button
                                            className="btn-activate"
                                            onClick={() => handleActivateKey(key.KeyID)}
                                            disabled={loading}
                                        >
                                            ✅ تفعيل
                                        </button>
                                    )}
                                    
                                    <button
                                        className="btn-edit"
                                        onClick={() => handleOpenEditModal(key)}
                                        disabled={loading}
                                    >
                                        ✏️ تعديل
                                    </button>
                                    
                                    <button
                                        className="btn-delete"
                                        onClick={() => handleDeleteKey(key.KeyID)}
                                        disabled={loading || key.IsActive}
                                    >
                                        🗑️ حذف
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* ════════════════════════════════════════════════════════ */}
            {/* مودال إضافة مفتاح */}
            {/* ════════════════════════════════════════════════════════ */}
            
            {showAddModal && (
                <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <h2>➕ إضافة مفتاح جديد</h2>
                        
                        <form onSubmit={handleAddKey}>
                            <div className="form-group">
                                <label>نوع الخدمة:</label>
                                <select
                                    value={newKey.serviceType}
                                    onChange={e => setNewKey({...newKey, serviceType: e.target.value})}
                                    required
                                >
                                    <option value="Gemini">🤖 Gemini</option>
                                    <option value="Azure">☁️ Azure</option>
                                </select>
                            </div>
                            
                            <div className="form-group">
                                <label>اسم المفتاح:</label>
                                <input
                                    type="text"
                                    value={newKey.keyName}
                                    onChange={e => setNewKey({...newKey, keyName: e.target.value})}
                                    placeholder="مثال: المفتاح الرئيسي"
                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>API Key:</label>
                                <textarea
                                    value={newKey.apiKey}
                                    onChange={e => setNewKey({...newKey, apiKey: e.target.value})}
                                    placeholder="الصق المفتاح هنا..."
                                    rows={3}
                                    required
                                />
                            </div>
                            
                            {newKey.serviceType === 'Azure' && (
                                <div className="form-group">
                                    <label>Endpoint:</label>
                                    <input
                                        type="url"
                                        value={newKey.endpoint}
                                        onChange={e => setNewKey({...newKey, endpoint: e.target.value})}
                                        placeholder="https://your-resource.cognitiveservices.azure.com/"
                                        required
                                    />
                                </div>
                            )}
                            
                            <div className="form-group">
                                <label>ملاحظات (اختياري):</label>
                                <textarea
                                    value={newKey.notes}
                                    onChange={e => setNewKey({...newKey, notes: e.target.value})}
                                    placeholder="أي ملاحظات..."
                                    rows={2}
                                />
                            </div>
                            
                            <div className="modal-actions">
                                <button type="submit" className="btn-submit" disabled={loading}>
                                    ✅ إضافة
                                </button>
                                <button 
                                    type="button" 
                                    className="btn-cancel"
                                    onClick={() => setShowAddModal(false)}
                                    disabled={loading}
                                >
                                    ❌ إلغاء
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ════════════════════════════════════════════════════════ */}
            {/* مودال تعديل مفتاح */}
            {/* ════════════════════════════════════════════════════════ */}
            
            {showEditModal && (
                <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <h2>✏️ تعديل المفتاح</h2>
                        
                        <form onSubmit={handleSaveEdit}>
                            <div className="form-group">
                                <label>نوع الخدمة:</label>
                                <input
                                    type="text"
                                    value={editKey.serviceType}
                                    disabled
                                    style={{ background: '#f0f0f0', cursor: 'not-allowed' }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>اسم المفتاح:</label>
                                <input
                                    type="text"
                                    value={editKey.keyName}
                                    onChange={e => setEditKey({...editKey, keyName: e.target.value})}
                                    placeholder="مثال: المفتاح الرئيسي"
                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>API Key (اتركه فارغاً إن لم تريد تغييره):</label>
                                <textarea
                                    value={editKey.apiKey}
                                    onChange={e => setEditKey({...editKey, apiKey: e.target.value})}
                                    placeholder="الصق المفتاح هنا..."
                                    rows={3}
                                />
                            </div>
                            
                            {editKey.serviceType === 'Azure' && (
                                <div className="form-group">
                                    <label>Endpoint:</label>
                                    <input
                                        type="url"
                                        value={editKey.endpoint}
                                        onChange={e => setEditKey({...editKey, endpoint: e.target.value})}
                                        placeholder="https://your-resource.cognitiveservices.azure.com/"
                                        required
                                    />
                                    <small style={{ color: '#e74c3c', marginTop: '5px', display: 'block' }}>
                                        ⚠️ مثال صحيح: https://passport-ocr-vision.cognitiveservices.azure.com
                                    </small>
                                </div>
                            )}
                            
                            <div className="form-group">
                                <label>ملاحظات (اختياري):</label>
                                <textarea
                                    value={editKey.notes}
                                    onChange={e => setEditKey({...editKey, notes: e.target.value})}
                                    placeholder="أي ملاحظات..."
                                    rows={2}
                                />
                            </div>
                            
                            <div className="modal-actions">
                                <button type="submit" className="btn-submit" disabled={loading}>
                                    💾 حفظ التعديلات
                                </button>
                                <button 
                                    type="button" 
                                    className="btn-cancel"
                                    onClick={() => setShowEditModal(false)}
                                    disabled={loading}
                                >
                                    ❌ إلغاء
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Loading Overlay */}
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
        </div>
    );
};

export default APIKeysManager;